export default {
  resourceManagers: {
    searchPlaceholder: '搜索',
    all: '全部',
    back: '返回',
    searchResults: '搜索结果',
    audioUploader: {
      localUpload: '本地上传',
      tips: '浏览所有资产',
    },
    dialog: {
      tips: '只展示符合当前格式要求的资产',
    },
    apply: '应用筛选条件',
    clearAll: '清除全部',
    noDataTip: '暂无数据',
  },
}
